
export const adminIndicatorRoutes = {
  totalInvoices: "/dashboard/invoices",
  inReview: "/dashboard/invoices/pending",
  approved: "/dashboard/invoices/approved",
  admissions: "/dashboard/invoices",
} as const;

export const adminSystemStatRoutes = {
  hospitals: "/dashboard/providers",
  companies: "/dashboard/employees",
  auditors: "/dashboard/users",
  validationRate: "/dashboard/statistics",
} as const;

export const invoiceDistributionRoutes = {
  submitted: "/dashboard/invoices/pending",
  review: "/dashboard/invoices/pending",
  approved: "/dashboard/invoices/approved",
  paid: "/dashboard/invoices/approved",
  modify: "/dashboard/invoices/rejected",
} as const;

const hospitalStatRoutes: Record<string, string> = {
  invoices: "/dashboard/invoices",
  submitted: "/dashboard/invoices/pending",
  paid: "/dashboard/invoices/approved",
  review: "/dashboard/invoices/pending",
  approved: "/dashboard/invoices/approved",
  rejected: "/dashboard/invoices/rejected",
  revenue: "/dashboard/statistics",
};

const auditorStatRoutes: Record<string, string> = {
  invoices: "/dashboard/invoices",
  submitted: "/dashboard/invoices/pending",
  review: "/dashboard/invoices/pending",
  approved: "/dashboard/invoices/approved",
  paid: "/dashboard/invoices/approved",
  modify: "/dashboard/invoices/rejected",
  rejected: "/dashboard/invoices/rejected",
  validation: "/dashboard/requests",
};

const enterpriseStatRoutes: Record<string, string> = {
  invoices: "/dashboard/invoices",
  approved: "/dashboard/invoices/approved",
  expenses: "/dashboard/statistics",
  agents: "/dashboard/employees",
  admissions: "/dashboard/invoices",
  hf: "/dashboard/invoices",
  beneficiaries: "/dashboard/beneficiaries",
};

const adminStatRoutes: Record<string, string> = {
  invoices: "/dashboard/invoices",
  submitted: "/dashboard/invoices/pending",
  review: "/dashboard/invoices/pending",
  approved: "/dashboard/invoices/approved",
  paid: "/dashboard/invoices/approved",
  admissions: "/dashboard/invoices",
  modify: "/dashboard/invoices/rejected",
  validation: "/dashboard/requests",
};

export function getRoleStatRoute(role: AccountType, statId: string) {
  const maps = {
    admin: adminStatRoutes,
    hospital: hospitalStatRoutes,
    auditor: auditorStatRoutes,
    enterprise: enterpriseStatRoutes,
  };
  return maps[role][statId] ?? "/dashboard/admin";
}

export const listActionRoutes = {
  conventionView: "/dashboard/insurers",
  conventionEdit: "/dashboard/insurers",
  providerView: "/dashboard/providers/:id",
  providerEdit: "/dashboard/providers/:id/edit",
  invoiceView: "/dashboard/invoices/pending",
  invoiceEdit: "/dashboard/invoices/submit",
  branchEdit: "/dashboard/insurers",
  userEdit: "/dashboard/users/create",
  requestList: "/dashboard/requests",
  disputeCreate: "/dashboard/invoices",
} as const;

export const statisticsIndicatorRoutes: Record<string, string> = {
  admissions: "/dashboard/invoices",
  invoicedAmount: "/dashboard/invoices",
  avgCost: "/dashboard/invoices",
  companies: "/dashboard/employees",
  hospitals: "/dashboard/providers",
  employees: "/dashboard/employees",
};

export const activityTypeRoutes: Record<string, string> = {
  admission: "/dashboard/invoices",
  invoice: "/dashboard/invoices",
  request: "/dashboard/requests",
  employee: "/dashboard/employees",
  package: "/dashboard/claims/packages",
};

export const platformMetricRoutes: Record<string, string> = {
  providers: "/dashboard/providers",
  employees: "/dashboard/employees",
  beneficiaries: "/dashboard/beneficiaries",
  packages: "/dashboard/claims/packages",
};

export const authorizationSummaryRoutes = {
  total: "/dashboard/requests",
  pending: "/dashboard/requests",
  approved: "/dashboard/requests",
  rejected: "/dashboard/requests",
} as const;

export const statisticsChartRoutes = {
  monthlyAdmissions: "/dashboard/invoices",
  monthlyInvoiced: "/dashboard/invoices",
  admissionStatuses: "/dashboard/invoices",
  invoiceStatuses: "/dashboard/invoices/pending",
  topMedicalActs: "/dashboard/acts",
  frequentDiagnostics: "/dashboard/acts/standard-diagnostics",
  companyExpenses: "/dashboard/employees",
  topHospitals: "/dashboard/providers",
} as const;
